import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from '../../store/messageSlice';
import { authService, LoginParams } from '../auth/services';
import { MessageType, setAuthenInfo } from './../../store/authenInfoSlice';
import { Profile } from './data';
import { profileService } from './services';
import { StatusAccount } from '../login/type';

export const loginDispatch = createAsyncThunk(
  '/api/auth/login',
  async (data: LoginParams, thunkAPI) => {
    try {
      const res = await authService.login(data);
      if (res?.data?.message === 'success') {
        if (res?.data?.data?.isFirstLogin) {
          localStorage.setItem('user', JSON.stringify(res?.data?.data));
          return res?.data?.data;
        } else {
          localStorage.setItem('user', JSON.stringify(res?.data?.data));
          return res?.data?.data;
        }
      }

    } catch (error: any) {
      const infoAuth: any = {isPreLogin: true};
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();


      const countWrong = error?.response?.data?.data?.countWrong || 0;

      if (countWrong) {
        if ( countWrong >= 5) {
          infoAuth['countWrong'] = countWrong;
          infoAuth['type'] = MessageType.LOCK;
          infoAuth['messageError'] =
            'Tài khoản của bạn đang bị hạn chế đăng nhập vì bạn đã đăng nhập sai thông tin vượt quá số lần cho phép. Vui lòng thử đăng nhập lại vào ngày mai';
        } else {
          infoAuth['countWrong'] = countWrong;
          infoAuth['type'] = MessageType.WARNING;
          infoAuth['messageError'] =
            'Vui lòng kiểm tra lại thông tin đăng nhập. Bạn còn 4 lần thử lại trong ngày hôm nay.';
        }
      }else {
        infoAuth['type'] = MessageType.NORMAL;
        infoAuth['messageError'] = message;
      }

      thunkAPI.dispatch(setAuthenInfo(infoAuth));
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const logoutDispatch = createAsyncThunk(
  '/api/auth/logout',
  async (_, thunkAPI) => {
    try {
      const res = await authService.logout();
      if (res.data.data.success) {
        localStorage.removeItem('user');
      }
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchCurrentUser = createAsyncThunk<
  Profile,
  undefined,
  { rejectValue: string }
>('profile', async (_, thunkAPI) => {
  try {
    const res = await profileService.get();
    const user = res.data.data;
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  } catch (error: any) {
    // localStorage.removeItem('user'); // comment row because dose not remove user if api has error (network)
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

type State = {
  currentUser?: Profile;
  isLoading: boolean;
  errorMessage: string;
};

const value = localStorage.getItem('user');
const user = typeof value === 'string' ? JSON.parse(value) : undefined;
const initialState: State = {
  currentUser: user,
  isLoading: false,
  errorMessage: '',
};

const profileSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // logout: (state) => {},
    setCurrentUser: (state, action) => {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.currentUser = action.payload;
    },
    // updateCurrentUser: (state, action) => {
    //   state.currentUser = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(loginDispatch.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginDispatch.fulfilled, (state, action) => {
      state.isLoading = false;
      state.currentUser = action.payload;
      if (
        action.payload?.isFirstLogin === false &&
        action.payload?.status === StatusAccount.INACTIVE
      ) {
        window.location.href = '/change-default-password';
        return;
      }

      if (
        action.payload?.isFirstLogin === false &&
        action.payload?.status === StatusAccount.ACTIVE
      ) {
        window.location.href = '/';
      }
    });
    builder.addCase(loginDispatch.rejected, (state, action) => {
      state.isLoading = false;
    });

    builder.addCase(logoutDispatch.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(logoutDispatch.fulfilled, (state) => {
      state.isLoading = false;
      state.currentUser = undefined;
    });
    builder.addCase(logoutDispatch.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.errorMessage = action.payload as string;
      } else {
        // state.errorMessage = action.error.message
      }
    });

    builder.addCase(fetchCurrentUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCurrentUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.currentUser = action.payload;
    });
    builder.addCase(fetchCurrentUser.rejected, (state, action) => {
      state.isLoading = false;
      state.currentUser = undefined;

      if (action.payload) {
        state.errorMessage = action.payload;
      } else {
        // state.errorMessage = action.error.message
      }
    });
  },
});

export const { setCurrentUser } = profileSlice.actions;
export default profileSlice;
